import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, ShieldCheck, Tag } from '../utils/icons';
import { useI18n } from '../i18n';

const Blog = () => {
  const { t } = useI18n();
  const postsValue = t('blog.posts');
  const blogPosts = Array.isArray(postsValue) ? postsValue : [];

  const fadeUp = {
    hidden: { opacity: 1, y: 18 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <div className="pt-20 ccc-site min-h-screen">
      <section className="ccc-brief-hero">
        <div className="ccc-container py-16 md:py-20">
          <p className="ccc-eyebrow mb-5">{t('ui.fieldNotes')}</p>
          <h1 className="ccc-brief-title">{t('blog.hero.title')}</h1>
          <p className="ccc-brief-copy mt-6 max-w-3xl">{t('blog.hero.subtitle')}</p>
        </div>
      </section>

      <section className="ccc-section">
        <div className="ccc-container">
          <div className="ccc-ledger p-6 md:p-8">
            <div className="mb-6 flex flex-col gap-3 border-b border-slate-200 pb-5 md:flex-row md:items-end md:justify-between">
              <div>
                <p className="ccc-eyebrow mb-3">{t('blog.label')}</p>
                <h2 className="text-3xl font-black text-slate-950 md:text-5xl">{t('ui.researchQueue')}</h2>
              </div>
              <p className="max-w-md text-sm leading-6 text-slate-600">{t('ui.researchQueueCopy')}</p>
            </div>

            <div>
              {blogPosts.map((post, index) => (
                <motion.article
                  key={post.title}
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  className="ccc-note-row"
                >
                  <div>
                    <p className="ccc-scope-number">NOTE-{String(index + 1).padStart(2, '0')}</p>
                    <div className="mt-4 flex flex-wrap gap-2">
                      <span className="ccc-pill">{post.status}</span>
                      <span className="ccc-pill">{post.category}</span>
                    </div>
                  </div>
                  <div>
                    <h2 className="text-2xl font-black text-slate-950">{post.title}</h2>
                    <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-slate-500">
                      <span className="inline-flex items-center gap-1">
                        <Calendar className="h-4 w-4" />
                        {post.date}
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <Tag className="h-4 w-4" />
                        {post.category}
                      </span>
                    </div>
                    <p className="ccc-work-copy mt-4">{post.excerpt}</p>
                  </div>
                  <ul className="space-y-3">
                    {post.points.map((point) => (
                      <li key={point} className="flex gap-2 text-sm leading-6 text-slate-700">
                        <ShieldCheck className="mt-1 h-4 w-4 flex-shrink-0 text-emerald-700" />
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </motion.article>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
